export class VoidType {
  static readonly value: VoidType = new VoidType();
}
